
import AppSelectBookYear from "@/components/bookyear/BookYearSelect.vue";
import AppToolbarButton from "@/components/common/ToolbarButton.vue";
import { AuthService } from "@/services/auth-service";
import { JobService } from "@/services/job-service";
import { NotificationService } from "@/services/notification-service";
import { TicketService } from "@/services/ticket-service";
import { ToolbarService } from "@/services/toolbar-service";
import AppNotificationsModal from "@/views/NotificationsModal.vue";
import Vue from "vue";
import { ISelectItem } from "winfakt-vue-components";
import AppToolbar from "./ToolbarBase.vue";
import { UserInfo } from "../../models/dossier/user-info";
import { tokenStore } from "../../utils/token-store";
import { BookYearService } from "@/services/book-year-service";
import { UserConfigService } from "@/services/user-config-service";
import { BrowserInfo } from "@/utils/browser";
import AppSelectDossier from "@/components/SelectDossier.vue";
import AppReferralGiftDropdown from "@/components/common/ReferralGiftDropdown.vue";
import { BookYear } from "@/models/book-year";

export default Vue.extend({
	data() {
		return {
			changeDossierModal: false,
			changeBookYearModal: false,
			notificationModal: false,
			ToolbarService,
			AuthService,
			tokenStore,
			JobService,
			currentBookYear: BookYearService.selectedBookYear,
			bookYears: [] as BookYear[],
			toolbarIframeData: UserConfigService.getGeneralSettings().ToolbarIframe
		};
	},
	computed: {
		toolbarIframeStyle(): any {
			if (this.toolbarIframeData.WidthMode === "fixed") {
				return { width: this.toolbarIframeData.FixedWidth + "px", flexShrink: 0 };
			}
			return { flexGrow: 1 };
		},
		toolbarIframeUrl(): string {
			if (!this.toolbarIframeData.Url) return "";
			let result = this.toolbarIframeData.Url.replaceAll("{{bookyear}}", `${this.currentBookYear}`);
			if (BrowserInfo.getElectronUrl()) {
				let electronUrl = new URL(BrowserInfo.getElectronUrl());
				result = result.replaceAll("{{electronUrl}}", electronUrl.href).replaceAll("{{electronPort}}", electronUrl.port);
				result = result.replaceAll("{{electronHost}}", electronUrl.host).replaceAll("{{electronHostname}}", electronUrl.hostname);
				if (this.toolbarIframeData.UseDesktopAppAsProxy) {
					let url = new URL(result);
					url.protocol = "http";
					url.host = url.hostname + ".prx." + electronUrl.host;
					result = url.href;
				}
			}
			return result;
		},
		showPreviousBookYearButton(): boolean{
			return this.bookYears.filter(f=>f.Year < this.currentBookYear).length > 0;
		},
		showNextBookYearButton(): boolean{
			return this.bookYears.filter(f=>f.Year > this.currentBookYear).length > 0;
		},
		showReferralGift(): boolean {
			return AuthService.wfUser != null;
		},
		pendingNotifications(): boolean {
			if (JobService.getQueuedJobs() > 0) {
				return true;
			}
			if (TicketService.unreadTickets.length > 0) {
				return true;
			}
			return NotificationService.hasPendingNotifications;
		},
		options(): any[] {
			let data = [
				{value: "logout", text: this.$ct("logout").toString()}
			];
			if (tokenStore.accessTokens.length > 1) {
				data.splice(1, 0, {
					value: "changeDossier",
					text: this.$ct("change-dossier").toString()
				});
			}
			return data;
		},
		loggedIn(): boolean {
			return AuthService.isLoggedIn;
		},
		wfUser(): UserInfo | null {
			return AuthService.wfUser;
		},
		currentDossier(): string {
			return AuthService.wfDossier.name;
		},
		appReady(): boolean {
			return AuthService.appReady;
		},
		// eslint-disable-next-line max-lines-per-function
		toolbarItems(): ISelectItem<any>[] {
			let items = [
				{
					text: this.$ct("bookyear-change", {bookyear: this.currentBookYear}),
					value: "changeBookYear",
					icon: "calendar-alt"
				},
				{
					text: this.$ct("notifications"),
					value: "openNotifications",
					icon: "bell"
				},
				{	text: this.$ct("account"),
					value: "account",
					icon: "user"
				},
				{	text: this.$ct("support"),
					value: "support",
					icon: "cog",
				},
			] as ISelectItem<any>[];
			if (this.tokenStore.accessTokens.length > 1) {
				items.push({
					text: this.$ct("change-dossier").toString(),
					value: "changeDossier",
					icon: "credit-card"
				});
			}
			items.push({
				value: "logout",
				text: this.$ct("logout"),
				icon: "sign-out-alt"
			});
			return items;
		}
	},
	methods: {
		logout() {
			AuthService.logout();
		},
		account() {
			this.$router.push("/account");
		},
		selectClicked(e: string) {
			if (typeof ((this as any)[e]) == "function") {
				(this as any)[e]();
			} else {
				this.$router.push(e);
			}
		},
		changeDossier() {
			this.changeDossierModal = true;
		},
		changeBookYear() {
			this.changeBookYearModal = true;
		},
		trigger(method: string) {
			(this as any)[method]();
		},
		openNotifications() {
			this.notificationModal = true;
		},
		goToSettings() {
			this.$router.push("/settings");
		},
		support(){
			this.$router.push("/support");
		},
		onBookYearChange(){
			this.currentBookYear = BookYearService.selectedBookYear;
		},
		async selectPreviousBookyear(){
			let result = this.bookYears.filter((c)=>c.Year < this.currentBookYear).sort((a,b)=>b.Year-a.Year);
			await BookYearService.selectBookYear(result[0]);
		},
		async selectNextBookyear(){
			let result = this.bookYears.filter((c)=>c.Year > this.currentBookYear).sort((a,b)=>a.Year - b.Year);
			await BookYearService.selectBookYear(result[0]);
		},
		onConfigsUpdated(){
			this.toolbarIframeData = UserConfigService.getGeneralSettings().ToolbarIframe;
		}
	},
	created(){
		BookYearService.on("bookyear-changed", this.onBookYearChange);
		UserConfigService.on("configs-updated", this.onConfigsUpdated);
		this.bookYears = BookYearService.bookYears;
	},
	destroyed(){
		BookYearService.off("bookyear-changed", this.onBookYearChange);
		UserConfigService.off("configs-updated", this.onConfigsUpdated);
	},
	components: {
		AppToolbar,
		AppSelectBookYear,
		AppNotificationsModal,
		AppToolbarButton,
		AppSelectDossier,
		AppReferralGiftDropdown
	},
	i18nEx: {
		componentPrefix: "components.common-DefaultToolbar"
	}
});
